import { render, staticRenderFns } from "./TemplatesUnpublishButton.vue?vue&type=template&id=35eeb3e6&scoped=true"
import script from "./TemplatesUnpublishButton.vue?vue&type=script&lang=js"
export * from "./TemplatesUnpublishButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eeb3e6",
  null
  
)

export default component.exports